const getDefaultState = () => {
  return {
    // The experience organiztion currently visible
    active: [],
    // Used to indicate when waiting on the server
    loading: false,
    // The search string being applied
    search: '',
    // What filters are currently applied
    filters: {},
    // The total records matching the filter according to the server (for pagination)
    total: 0,
    // The current page being viewed and its size
    page: 1,
    rowsPerPage: 25,
    // Sorting
    sort: {
      by: 'updatedAt',
      descending: false,
    },
  }
}

const state = getDefaultState()

const getters = {
  active: state => state.active,
  find: state => state.active.find(eo => eo.id == Vue.$route.params.id),
  loading: state => state.loading,
}

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState())
  },

  startLoading(state) {
    state.loading = true
  },

  stopLoading(state) {
    state.loading = false
  },

  setActive(
    state,
    {
      items = [],
      page = 1,
      per = 25,
      total = 0,
      search = null,
      sort = { by: 'updatedAt', descending: true },
      filters = {},
    }
  ) {
    state.search = search
    state.active = items
    state.sort = sort
    state.filters = filters
    state.page = page
    state.rowsPerPage = per
    state.total = total
    state.loading = false
  },

  set(state, experienceOrganization) {
    const find = state.active.find(eo => eo.id === experienceOrganization.id)
    if (find) state.active.splice(state.active.indexOf(find), 1, experienceOrganization)
    if (!find) state.active.push(experienceOrganization)
  },

  remove(state, id) {
    state.active = state.active.filter(eo => eo.id != id)
  },
}

const actions = {
  search(
    { commit, state },
    {
      search = '',
      page = 1,
      rowsPerPage = 25,
      sortBy = 'updatedAt',
      descending = true,
      filters = {},
    } = {}
  ) {
    this.$authorize('list', 'ExperienceOrganization')

    const params = {
      search: search,
      page: page,
      per: rowsPerPage,
      sort: `${sortBy} ${descending ? 'DESC' : 'ASC'}`,
      ...filters,
    }

    state.loading = true
    return Vue.$http
      .get('admin/experience_organizations', { params })
      .then(response => commit('setActive', response.data), error => (state.loading = false))
  },

  fetch({ commit }, id) {
    this.$authorize('read', 'ExperienceOrganization')

    return Vue.$http
      .get(`admin/experience_organizations/${id}`)
      .then(response => commit('set', response.data))
  },

  update({ commit }, { id, name, industry }) {
    this.$authorize('edit', 'ExperienceOrganization')

    return Vue.$http.patch(`admin/experience_organizations/${id}`, { name, industry }).then(
      response => {
        commit('set', response.data)
        return response
      },
      errors => {
        commit('set', { id, errors: errors.response.data.errors })
        throw errors.response.data
      }
    )
  },

  create({ commit }, { name, industry }) {
    this.$authorize('create', 'ExperienceOrganization')

    return Vue.$http.post(`admin/experience_organizations`, { name, industry }).then(
      response => {
        commit('set', response.data)
        return response.data
      },
      error => {
        throw error.response.data
      }
    )
  },

  destroy({ commit }, id) {
    this.$authorize('delete', 'ExperienceOrganization')

    return Vue.$http.delete(`admin/experience_organizations/${id}`).then(
      response => commit('remove', id),
      errors => {
        throw new Error()
        return errors
      }
    )
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
